import React, { useEffect } from 'react'
import { numberWithCommas } from 'utils/Utils';
import { prefixandsupfix } from 'utils/Constant';
import * as Actions from '../../state/Actions'
import Loader from 'components/loader/Loader'
import SectionError from 'components/error/SectionError'
import { useFetch } from 'hooks/useFetch'
import { capitalize } from 'proptypes/StringProptype';
import { removeItem } from 'proptypes/ArrayProptype';

/* ── design tokens ── */
const T = {
  bg:     '#F6F5F0',
  card:   '#FFFFFF',
  line:   '#E5E2D8',
  ink:    '#232821',
  mut:    '#6E766C',
  acc:    '#2E9E7A',
  shadow: '0 1px 2px rgba(35,40,33,.04), 0 4px 16px rgba(35,40,33,.06)',
};

const CompanyEssentialContainer = (props) => {
  const { url, title, unWantedKeys } = props
  let dispatch = Actions.getDispatch(React.useContext)
  const { data: rawData, loading, error, retry } = useFetch(url)
  const data = rawData || []

  // Dismiss global loader as soon as this section resolves (success or failure)
  useEffect(() => {
    if (!loading) {
      dispatch(Actions.stateChange('loader', false))
    }
  // eslint-disable-next-line
  }, [loading])

  let essentialfields = []
  if (data && data.length) {
    essentialfields = Object.keys(data[0]).map((key) => key)
    let filtered = essentialfields;
    unWantedKeys.forEach((key) => { filtered = removeItem(filtered, key); });
    essentialfields = filtered;
  }

  return (
    <div style={{ marginBottom: 16 }}>
      {loading ? (
        <Loader />
      ) : error ? (
        <SectionError message={error.message} onRetry={retry} />
      ) : data.length ? (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 10,
        }}>
          {essentialfields.map((field, index) => {
            const prefix = prefixandsupfix[field] ? prefixandsupfix[field].prefix : ''
            const suffix = prefixandsupfix[field] ? prefixandsupfix[field].supfix : ''
            const value  = numberWithCommas(data[0][field])
            return (
              <div key={index} style={{
                background: T.card,
                border: `1px solid ${T.line}`,
                borderRadius: 12,
                padding: '13px 16px',
                boxShadow: '0 1px 3px rgba(35,40,33,.04)',
              }}>
                <div style={{
                  fontSize: 10,
                  fontWeight: 600,
                  letterSpacing: '0.07em',
                  textTransform: 'uppercase',
                  color: T.mut,
                  marginBottom: 5,
                }}>
                  {capitalize(field.replace(/_/g, ' '))}
                </div>
                <div style={{
                  fontSize: 15,
                  fontWeight: 700,
                  color: T.ink,
                  fontVariantNumeric: 'tabular-nums',
                }}>
                  {prefix}{value}{suffix}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div style={{ color: T.mut, fontSize: 13, textAlign: 'center', padding: '24px 0' }}>
          No data available
        </div>
      )}
    </div>
  )
}

export default CompanyEssentialContainer
